import { Component, Input } from "@angular/core";

import { PageObjectLink } from "src/app/models/pageobjectlink";

@Component({
  selector: "hkt-pageobjectlink",
  templateUrl: "./pageobjectlink.component.html",
  styleUrls: ["./pageobjectlink.component.scss"],
})
export class PageObjectLinkComponent {
  @Input("obj") obj: PageObjectLink;
  @Input("mode") mode: string;

  constructor() {}
}
